// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kBcL","rootNoMargin":"styles_rootNoMargin__1iHDv"};